module.exports = __webpack_public_path__ + "img/background.48d1af9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/background.jpg
// module id = 1306
// module chunks = 1